export const MAX_CUMULATIVE_DRAW_AREA_KM2 = 500;

export const MAX_DRAW_FEATURE_COUNT = 1000;
